import styled from 'styled-components';
import {
  Tabs,
} from 'antd';
import {
  COLOR_CV_5,
  COLOR_NEUTRAL_13,
} from 'constants/colors';

export const StyledAntdTabs = styled(Tabs)`
  .ant-tabs-tab {
    & .ant-tabs-tab-btn {
      color: ${COLOR_NEUTRAL_13}45;
    }
  }
  .ant-tabs-tab.ant-tabs-tab-active {
    & .ant-tabs-tab-btn {
      color: ${COLOR_CV_5};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLOR_CV_5};
  }
`;
